import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { RootState } from '../app/store';

function PublicOnlyRoute({ children }: { children: JSX.Element }) {
  const loggedIn    = useSelector((state: RootState) => state.session.loggedIn);
  const currentUser = useSelector((state: RootState) => state.session.currentUser);
  const location    = useLocation();

  if (loggedIn && currentUser?.nickname) {
    return <Navigate to={`/users/${currentUser.nickname}/contents`} state={{ from: location }} replace />;
  }

  return children;
}

export default PublicOnlyRoute;
